"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.BehaviorCodeEntryUpdateNotesDto = void 0;
const mappable_base_1 = require("../../mappable.base");
const class_validator_1 = require("class-validator");
class BehaviorCodeEntryUpdateNotesDto extends mappable_base_1.MappableBase {
    constructor(behaviorCodeEntryOptions) {
        super();
        if (!behaviorCodeEntryOptions)
            return;
        Object.assign(this, behaviorCodeEntryOptions);
    }
    getFields() {
        return ['notes'];
    }
    notes;
}
exports.BehaviorCodeEntryUpdateNotesDto = BehaviorCodeEntryUpdateNotesDto;
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.MaxLength)(65500, {
        message: 'Notes can not be more than 64kb. Generally your notes should be much smaller than that. Please avoid storing chunks of text here unless absolutely necessary.'
    }),
    __metadata("design:type", String)
], BehaviorCodeEntryUpdateNotesDto.prototype, "notes", void 0);
